const url = '/travelAgencyAccounts';
const Provider = 'TravelAgencyAccounts';
const dbModel = 'TravelAgencyAccounts';

export { url, Provider, dbModel };
